import RowItemWidget from './rowItemWidget'
import {
  ACTION_FETCH_ROPA_SUMMARY,
  RopaSummary,
  fetchRopaSummary
} from '../privacyOpsOverviewSlice'
import { RootState } from '../../../rootReducer'
import { getShowLoader } from '../../../reducers/requestReducer'
import { getUpdatedUrl } from '../../../utils/urlUtil'
import {
  FILTER_REVIEW_STATUS,
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  ProcessReviewStatus,
  URL_DEFINED_PROCESSES,
  URL_ROPA
} from '../../../constants'
import { useIntl } from 'react-intl'
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'

interface IProps {
  showLoader: boolean
  ropaSummary: RopaSummary
  timePeriod?: string
  fetchRopaSummary: (timePeriod: string) => void
}

const RopaSummaryWidget = ({
  ropaSummary,
  showLoader,
  timePeriod = '',
  fetchRopaSummary
}: IProps) => {
  const intl = useIntl()

  useEffect(() => {
    fetchRopaSummary(timePeriod)
  }, [fetchRopaSummary, timePeriod])

  const widgetData = useMemo(
    () =>
      Object.keys(ropaSummary).length
        ? [
            {
              key: intl.formatMessage({ id: 'po.dashboard.ropaSummary.widget.line1' }),
              value: ropaSummary.totalProcesses,
              link: getUpdatedUrl({
                pathName: `${URL_ROPA}${URL_DEFINED_PROCESSES}`,
                pageName: URL_DEFINED_PROCESSES,
                pageQueryParams: {
                  [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list
                }
              })
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.ropaSummary.widget.line2' }),
              value: ropaSummary.processesNeedAttention,
              link: getUpdatedUrl({
                pathName: `${URL_ROPA}${URL_DEFINED_PROCESSES}`,
                pageName: URL_DEFINED_PROCESSES,
                pageQueryParams: {
                  [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
                  [FILTER_REVIEW_STATUS]: [
                    ProcessReviewStatus.reviewDue,
                    ProcessReviewStatus.reviewPastDue
                  ].join(',')
                }
              })
            },
            {
              key: intl.formatMessage({ id: 'po.dashboard.ropaSummary.widget.line4' }),
              value: ropaSummary.unmappedAttributeTypes
            }
          ]
        : [],
    [ropaSummary]
  )

  return (
    <RowItemWidget
      widgetData={widgetData}
      title={intl.formatMessage({ id: 'po.dashboard.ropaSummary.widget.title' })}
      showLoader={showLoader}
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  ropaSummary: state.privacyOpsOverview.ropaSummary,
  timePeriod: state.customDashboards.filterProps.timePeriod,
  showLoader: getShowLoader(ACTION_FETCH_ROPA_SUMMARY)
})
const mapDispatchToProps = { fetchRopaSummary }

export default connect(mapStateToProps, mapDispatchToProps)(RopaSummaryWidget)
